export default __webpack_public_path__ + "static/media/head_banner_mob.f02699c5.webp";